import { Settings, StreamrWrapper, } from '@streamr/tv-engine';
import { areEqualBinaries, toUserId, } from '@streamr/utils';
import { Mutex } from 'async-mutex';
import { EventEmitter } from 'eventemitter3';
import { MediaManager } from './streamrapp/MediaManager';
export class StreamrAppApi extends EventEmitter {
    streamrWrapper;
    mediaManager;
    mutex;
    heartbeatTimeoutRef;
    heartbeatIntervalRef;
    streamId;
    broadcasterUserId;
    aesKey;
    constructor(opts) {
        super();
        this.streamId = opts.streamId;
        this.broadcasterUserId = opts.broadcasterUserId;
        this.aesKey = opts.aesKey;
        this.mediaManager = new MediaManager();
        this.mutex = new Mutex();
    }
    async start() {
        await this.mutex.acquire();
        try {
            this.streamrWrapper = new StreamrWrapper({
                aesKey: this.aesKey,
            });
            await this.mediaManager.init(this.streamrWrapper);
            // Set up event listeners
            this.streamrWrapper.on('mediaPacketFragment', this.onMediaPacketFragment);
            this.streamrWrapper.on('broadcastMetadata', this.onBroadcastMetadataChanged);
            this.streamrWrapper.on('pluginMessage', this.onPluginMessage);
            this.streamrWrapper.on('purchaseConfirmedMessage', this.onPurchaseConfirmedMessage);
            await this.streamrWrapper.start(this.streamId);
            // Emit event so services can register with the wrapper
            this.emit('streamrWrapperReady', this.streamrWrapper);
            this.setupHeartbeat();
        }
        finally {
            this.mutex.release();
        }
    }
    async stop() {
        await this.mutex.acquire();
        try {
            this.clearHeartbeatTimers();
            window.removeEventListener('beforeunload', this.onBeforeUnload);
            this.sendLeave();
            this.streamrWrapper?.off('mediaPacketFragment', this.onMediaPacketFragment);
            this.streamrWrapper?.off('broadcastMetadata', this.onBroadcastMetadataChanged);
            this.streamrWrapper?.off('pluginMessage', this.onPluginMessage);
            this.streamrWrapper?.off('purchaseConfirmedMessage', this.onPurchaseConfirmedMessage);
            await this.mediaManager.stop();
            //await this.streamrWrapper?.stop();
        }
        finally {
            this.mutex.release();
        }
    }
    getMediaManager() {
        return this.mediaManager;
    }
    getStreamrWrapper() {
        if (!this.streamrWrapper) {
            throw new Error('Streamr wrapper not initialized');
        }
        return this.streamrWrapper;
    }
    clearHeartbeatTimers() {
        if (this.heartbeatTimeoutRef) {
            clearTimeout(this.heartbeatTimeoutRef);
            this.heartbeatTimeoutRef = undefined;
        }
        if (this.heartbeatIntervalRef) {
            clearInterval(this.heartbeatIntervalRef);
            this.heartbeatIntervalRef = undefined;
        }
    }
    onMediaPacketFragment = (packet, publisherId, messageChainId) => {
        //console.log('onMediaPacketFragment', packet, publisherId);
        /*
        if (!areEqualBinaries(publisherId, this.broadcasterUserId)) {
            console.log(
                'Skipping broadcast metadata change (message is not from broadcaster)',
            );
            return;
        }*/
        this.mediaManager.feedMediaPacketFragment(packet, toUserId(publisherId), messageChainId);
        this.emit('receivedFrame');
    };
    onBroadcastMetadataChanged = (broadcastMetadata, _publisherId) => {
        /*
        if (!areEqualBinaries(publisherId, this.broadcasterUserId)) {
            console.log(
                'Skipping broadcast metadata change (message is not from broadcaster)',
            );
            return;
        }
        */
        this.emit('broadcastMetadataChanged', broadcastMetadata);
    };
    sendLeave = () => {
        if (!this.streamrWrapper) {
            return;
        }
        this.streamrWrapper.publishLeave();
    };
    sendHeartbeat = () => {
        if (!this.streamrWrapper) {
            return;
        }
        this.streamrWrapper.publishHeartbeat(false);
    };
    onBeforeUnload = () => {
        this.sendLeave();
    };
    setupHeartbeat() {
        window.addEventListener('beforeunload', this.onBeforeUnload);
        this.sendHeartbeat();
        const randomDelay = Math.floor(Math.random() * Settings.defaultHeartbeatInterval);
        this.heartbeatTimeoutRef = setTimeout(() => {
            this.heartbeatTimeoutRef = undefined;
            this.sendHeartbeat();
            this.clearHeartbeatTimers();
            this.heartbeatIntervalRef = setInterval(() => {
                this.sendHeartbeat();
            }, Settings.defaultHeartbeatInterval);
        }, randomDelay);
    }
    onPluginMessage = (message, publisherId) => {
        this.emit('pluginMessage', message, publisherId);
    };
    onPurchaseConfirmedMessage = (message, publisherId) => {
        if (!areEqualBinaries(publisherId, this.broadcasterUserId)) {
            console.log('Skipping purchase confirmed message (message is not from broadcaster)');
            return;
        }
        this.emit('purchaseConfirmedMessage', message, publisherId);
    };
}
